import type * as types from "./types";

import { useUser } from "@components/user-context";

export const useClient = (options?: types.InternalOptions) => {
  const {
    user: {
      cpuIntensiveApolloClient,
      heavyApolloClient,
      jobManagerApolloClient,
      apolloClient,
    },
  } = useUser();
  if (options?.useCpuIntensive) {
    return cpuIntensiveApolloClient;
  } else if (options?.useHeavy) {
    return heavyApolloClient;
  } else if (options?.useJobManager) {
    return jobManagerApolloClient;
  } else {
    return apolloClient;
  }
};
